module.exports = __webpack_public_path__ + "static/img/SA.04ad3946.png";